import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { FormControl, FormGroup } from '@angular/forms';
import { QrPopupComponent } from '../qr-popup/qr-popup.component';
import { NbDialogService } from '@nebular/theme';
import { ApiUrl } from 'src/app/services/apiUrl';
import { ApiService } from 'src/app/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { StoreUrlComponent } from './store-url/store-url.component';
import { StoreOpeningHoursComponent } from './store-opening-hours/store-opening-hours.component';
import { CopyStoreDialogComponent } from './copy-store-dialog/copy-store-dialog.component';

@Component({
  selector: 'app-stores',
  templateUrl: './stores.component.html',
  styleUrls: ['./stores.component.scss'],
})
export class StoresComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  role: any = localStorage.getItem('role');
  id: any;
  storeForm: any;
  page: any = 1;
  total: any = 0;
  pageSize = 10;
  selectedPage: any;
  storeList: any;
  word: any = '';
  count: number = 5;
  managerId = localStorage.getItem('managerId');
  timeout: any = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: NbDialogService,
    private service: ApiService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.page = +params['page'] || 1;
      this.word = params['word'] || '';
      this.selectedPage = this.page;
      this.showList();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private storesReturnParams(): { storesPage?: number; storesWord?: string } {
    const params: { storesPage?: number; storesWord?: string } = {};
    if (this.page > 1) {
      params.storesPage = this.page;
    }
    if (this.word) {
      params.storesWord = this.word;
    }
    return params;
  }

  showList() {
    this.spinner.show();
    if (this.role == 'manager' && this.managerId) {
      this.service
        .getRequest(
          `${ApiUrl.storeListById}${this.managerId}` +
            `?page=` +
            this.page +
            `&word=` +
            this.word
        )
        .subscribe(
          (res: any) => {
            // console.log(res,"res...............")

            this.storeList = res.response?.data;
            //  console.log(this.storeList,"res...............")
            this.total = res.response?.data?.storeCount;
            this.spinner.hide();
            // console.log(this.storeList,"resLIst...............")
          },
          (err) => {
            this.spinner.hide();
          }
        );
    } else {
      this.spinner.show();
      this.service
        .getRequest(
          ApiUrl.storeList + `?page=` + this.page + `&word=` + this.word
        )
        .subscribe(
          (res: any) => {
            this.storeList = res.response?.data?.storesData;
            this.total = res.response?.data?.storeCount;
            this.spinner.hide();
          },
          (err) => {
            this.spinner.hide();
          }
        );
    }
  }

  // showList() {
  //   this.service.getRequest(ApiUrl.storeList + `?page=` + this.page + `&word=` + this.word).subscribe((res: any) => {
  //     this.storeList = res.response?.data?.storesData;
  //     this.total = res.response?.data?.storeCount

  //   })
  // }

  getStoreById() {
    this.spinner.show();
    this.service
      .getRequest(`${ApiUrl.storeListById}${this.managerId}`)
      .subscribe(
        (res: any) => {
          // console.log(res)
          this.spinner.hide();
          // this.storeForm.patchValue({
          //   storeName:res.data?.storeName
          // })
        },
        (err) => {
          this.toastr.error(err.error?.response?.message);
          this.spinner.hide();
        }
      );
  }

  addStores() {
    this.router.navigate(['/storeforms']);
  }

  editStore(id: any) {
    this.router.navigate(['/editstore/' + id], {
      queryParams: this.storesReturnParams(),
    });
  }
  storeOpening(id: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to open this door?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, open it!',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        this.spinner.show();
        this.service.getRequest(`${ApiUrl.storeOpening}${id}`).subscribe(
          (res: any) => {
            // console.log(res)
            if (res) {
              this.toastr.success('Store Opened Successfully');
              this.spinner.hide();
            }
          },
          (err) => {
            this.toastr.error(err.error?.response?.message);
            this.spinner.hide();
          }
        );
      }
    });
  }

  viewNfcMonitoring(id: any) {
    this.router.navigate(['/nfc-monitoring/store', id], {
      queryParams: { ...this.storesReturnParams(), storesPage: this.page },
    });
  }

  openEcommerceAdmin(id: any) {
    this.router.navigate(['/store', id, 'ecommerce'], {
      queryParams: this.storesReturnParams(),
    });
  }

  openPosTerminals(id: any) {
    this.router.navigate(['/store', id, 'pos-terminals'], {
      queryParams: this.storesReturnParams(),
    });
  }

  confirmDelete() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this data!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        this.deletStore(this.id);
      }
    });
  }

  deletStore(id: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this data!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        this.spinner.show();
        this.service.deletRequest(`${ApiUrl.deleteStore}/${id}`).subscribe(
          (res: any) => {
            this.toastr.success(res.response.message);
            this.showList();
            this.spinner.hide();
          },
          (err) => {
            this.toastr.error(err.error?.response?.message);
            this.spinner.hide();
          }
        );
      }
    });
  }

  onFilterKeySearch() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      const currentPage = +this.route.snapshot.queryParamMap.get('page')! || 1;
      const currentWord = this.route.snapshot.queryParamMap.get('word') || '';
      const wordSame = currentWord === (this.word || '');
      if (currentPage === 1 && wordSame) {
        this.page = 1;
        this.showList();
        return;
      }
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { page: null, word: this.word || null },
        queryParamsHandling: 'merge',
        replaceUrl: true,
      });
    }, 1000);
  }

  pageChanged(event: any) {
    this.selectedPage = event;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        page: event > 1 ? event : null,
        word: this.word || null,
      },
      queryParamsHandling: 'merge',
    });
  }

  open(id: any) {
    this.dialogService.open(QrPopupComponent, {
      context: {
        title: 'Qr Image',
        id: id,
      },
    });
  }

  openDialog(id: any) {
    this.dialogService.open(StoreUrlComponent, {
      context: {
        // title: 'Qr Image',
        id: id,
      },
    });
  }
  openTimingDialog(id: any) {
    this.dialogService.open(StoreOpeningHoursComponent, {
      context: {
        id: id,
      },
    });
  }

  copyStore(store: any) {
    const dialogRef = this.dialogService.open(CopyStoreDialogComponent, {
      context: {
        storeId: store._id,
        storeName: store.storeName,
      },
    });
    dialogRef.onClose.subscribe((result: any) => {
      if (result?.refresh) {
        this.showList();
      }
    });
  }
}
